"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FocusTrap = void 0;
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var kaltura_player_js_1 = require("@playkit-js/kaltura-player-js");
var withEventManager = kaltura_player_js_1.ui.Event.withEventManager;
var FOCUSABLE_ELEMENTS_QUERY = 'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])';
exports.FocusTrap = withEventManager(function (_a) {
    var children = _a.children, active = _a.active, eventManager = _a.eventManager;
    var trapRef = (0, hooks_1.useRef)(null);
    var setupFocusTrap = (0, hooks_1.useCallback)(function () {
        if (!active)
            return;
        var trapElement = trapRef.current;
        if (!trapElement)
            return;
        var focusableElements = trapElement.querySelectorAll(FOCUSABLE_ELEMENTS_QUERY);
        if (focusableElements.length === 0)
            return;
        var firstElement = focusableElements[0];
        var lastElement = focusableElements[focusableElements.length - 1];
        var handleKeyDown = function (e) {
            if (e.key === 'Tab') {
                if (e.shiftKey && document.activeElement === firstElement) {
                    e.preventDefault();
                    lastElement.focus();
                }
                else if (!e.shiftKey && document.activeElement === lastElement) {
                    e.preventDefault();
                    firstElement.focus();
                }
            }
        };
        eventManager === null || eventManager === void 0 ? void 0 : eventManager.unlisten(document, 'keydown', handleKeyDown);
        eventManager === null || eventManager === void 0 ? void 0 : eventManager.listen(document, 'keydown', handleKeyDown);
    }, [active]);
    (0, hooks_1.useEffect)(function () {
        if (!active)
            return;
        var observer = new MutationObserver(function () {
            setupFocusTrap();
        });
        var trapElement = trapRef.current;
        if (trapElement) {
            observer.observe(trapElement, {
                childList: true,
                subtree: true
            });
        }
        setupFocusTrap();
        return function () {
            if (trapElement) {
                observer.disconnect();
            }
        };
    }, [active, setupFocusTrap]);
    return (0, preact_1.h)("div", { ref: trapRef }, children);
});
//# sourceMappingURL=index.js.map